import { useEffect } from "react";
import s from "./QuizQuestions.module.scss";
import { useQuizModalStore } from "@/zustand/quizModalStore.js";

const base = window.post_template.checkout_v4_quiz || {};
const questionLabel = base?.tr_quiz_settings_question_label;
const outOfLabel = base?.tr_quiz_settings_out_of_label;
const quizQuestions = base.quiz_settings_quiz_questions
  ? base.quiz_settings_quiz_questions.map((q) => ({
      question: q.tr_quiz_question,
      answers: q.quiz_answers.map((a) => a.tr_quiz_answer),
    }))
  : [];

const QuizQuestions = ({ step, onNext }) => {
  const { setQuizPhase } = useQuizModalStore();

  useEffect(() => {
    if (quizQuestions.length === 0) {
      setQuizPhase("loader");
    } else if (step >= quizQuestions.length) {
      setQuizPhase("loader");
    }
  }, [setQuizPhase, step]);

  if (quizQuestions.length === 0 || step >= quizQuestions.length) {
    return <div>Add Questions</div>;
  }

  return (
    <section className={s["questions"]}>
      <h1 className={s["questions__question"]}>{quizQuestions[step].question}</h1>
      <ul className={s["questions__list"]}>
        {quizQuestions[step].answers.map((item, index) => (
          <li className={s["questions__list--answers"]} key={index} onClick={onNext}>
            {item}
          </li>
        ))}
      </ul>
      <p className={s["questions__count"]}>
        {step + 1} {outOfLabel} {quizQuestions.length} {questionLabel}
      </p>
    </section>
  );
};

export default QuizQuestions;
